import { Link } from "@cjdev-internal/visual-stack-x/components/Link";

export const ExternalLink = ({ href, children }) => (
  <Link href={href} target="_blank" rel="noreferrer">
    {children}
  </Link>
);
